import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { TableList, Typography, TableListActions, DropdownMenuItem } from 'seagull';
import { Archive, Edit, Trash, Unarchive } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { OwnerCell } from './OwnerCell';
export const GetClientRowTID = (parentTestId)=>getTestIds(parentTestId);
export function ClientRow(param) {
    let { client, testId, onArchiveClient, onUnarchiveClient, onDeleteClient, onEditClient, onViewClient } = param;
    var _client_lastInvoiceDate, _client_nextInvoiceDate;
    const { t: clientsDashboardTexts } = useLocaleKeys('pages.clientsDashboard');
    const { ClientRowTestIds: TID } = useMemo(()=>GetClientRowTID(testId), [
        testId
    ]);
    return /*#__PURE__*/ _jsx(TableList.Row, {
        rowId: client.id,
        testId: TID.Root(),
        onClick: ()=>onViewClient(client),
        items: [
            {
                value: /*#__PURE__*/ _jsx(Typography, {
                    ellipsis: true,
                    weight: "normal",
                    testId: TID.Name(),
                    children: client.name
                })
            },
            {
                value: clientsDashboardTexts.status[client.status](),
                testId: TID.Status()
            },
            {
                value: /*#__PURE__*/ _jsx(Typography, {
                    weight: "light",
                    testId: TID.Type(),
                    children: clientsDashboardTexts.type[client.type]()
                })
            },
            {
                value: /*#__PURE__*/ _jsx(OwnerCell, {
                    client: client,
                    testId: TID.Owner()
                })
            },
            {
                value: /*#__PURE__*/ _jsx(Typography, {
                    weight: "light",
                    testId: TID.LastInvoice(),
                    children: (_client_lastInvoiceDate = client.lastInvoiceDate) !== null && _client_lastInvoiceDate !== void 0 ? _client_lastInvoiceDate : '-'
                })
            },
            {
                value: /*#__PURE__*/ _jsx(Typography, {
                    weight: "light",
                    testId: TID.NextInvoice(),
                    children: (_client_nextInvoiceDate = client.nextInvoiceDate) !== null && _client_nextInvoiceDate !== void 0 ? _client_nextInvoiceDate : '-'
                })
            }
        ],
        actionColumn: /*#__PURE__*/ _jsxs(TableListActions, {
            testId: TID.Actions(),
            btnHeapId: "client-view-btn",
            onClickButton: ()=>onViewClient(client),
            mobile: {
                title: client.name
            },
            children: [
                /*#__PURE__*/ _jsx(DropdownMenuItem, {
                    bi: {
                        name: 'client_edit'
                    },
                    iconStart: /*#__PURE__*/ _jsx(Edit, {}),
                    onClick: ()=>onEditClient(client),
                    testId: TID.ActionEdit(),
                    children: clientsDashboardTexts.actions.edit()
                }, "edit"),
                client.status === 'active' ? /*#__PURE__*/ _jsx(DropdownMenuItem, {
                    bi: {
                        name: 'client_archive'
                    },
                    iconStart: /*#__PURE__*/ _jsx(Archive, {}),
                    onClick: ()=>onArchiveClient(client),
                    testId: TID.ActionArchive(),
                    children: clientsDashboardTexts.actions.archive()
                }, "archive") : /*#__PURE__*/ _jsx(DropdownMenuItem, {
                    bi: {
                        name: 'client_unarchive'
                    },
                    iconStart: /*#__PURE__*/ _jsx(Unarchive, {}),
                    onClick: ()=>onUnarchiveClient(client),
                    testId: TID.ActionUnarchive(),
                    children: clientsDashboardTexts.actions.unarchive()
                }, "unarchive"),
                /*#__PURE__*/ _jsx(DropdownMenuItem, {
                    bi: {
                        name: 'client_delete'
                    },
                    iconStart: /*#__PURE__*/ _jsx(Trash, {}),
                    onClick: ()=>onDeleteClient(client),
                    testId: TID.ActionDelete(),
                    skin: "error",
                    children: clientsDashboardTexts.actions.delete()
                }, "delete")
            ]
        })
    });
}
